import getPermissionsFromTree from '../../../shared/authorization/getPermissionsFromTree.helper';
import permissionTypes from '../../../shared/authorization/permissionTypes';
import permissionPaths from '../../../shared/authorization/permissionPaths';

const isHelpEditable = user => (
  user ? getPermissionsFromTree(user.permissions, permissionPaths.HELP, null)[permissionTypes.MODIFY] : false
);

export default isHelpEditable;
